import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-commission-modal',
  templateUrl: './commission-modal.component.html',
  styleUrls: ['./commission-modal.component.scss']
})
export class CommissionModalComponent implements OnInit {

  @Input() set playerUUID(player_uuid: any) {
    this.player_uuid = player_uuid;
    this.init(player_uuid)
  };

  @Output() saveEvent = new EventEmitter();
  public is_loading = false;
  private player_uuid: any;

  public transaction: any = { type: "withdraw-commission" }
  public data: any = { banks: [] };
  public banks: any = []
  public setting: any = {}
  public user_permission: any = {};
  constructor(public http: HttpService) { 
    this.user_permission = this.http.getSelecetdCompanyDetail();
  }

  async ngOnInit(): Promise<void> {
    await this.http.getPermission();
  }

  async init(player_uuid) {
    this.is_loading = true
    const rtn = await this.http.post("/admin/player/get/summary/all", { player_uuid: player_uuid, status: 1 });
    this.data = rtn['player']
    this.banks = rtn['bank']
    this.setting = rtn['setting'];
    this.is_loading = false;
  }

  fcRateChange() {
    if (this.transaction.finance_charge == "true") {
      this.transaction.finance_charge_rate = this.setting.finance_charge_rate;
    } else {
      delete this.transaction.finance_charge_rate
    }

  }

  async save() {
    const data = this.transaction;
    data.player_uuid = this.player_uuid
    const s: any = await this.http.post("/admin/player/transaction", data);
    // The transfer-to-wallet override returns { status:false, message } on a rejected
    // validation (bad amount / insufficient balance / missing reason). Surface it and
    // keep the modal open so the operator can correct instead of silently "saving".
    if (s && s.status === false) {
      this.http.notify(s.message || 'Transaction failed.');
      return;
    }
    this.saveEvent.emit(true)
  }

  close() {
    this.saveEvent.emit(false)
  }
}
